var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import * as React from 'react';
import classNames from 'classnames';
import { DivTag, SpanTag } from '../../Utils/AtomicTag';
import Checkbox from '../Checkbox';
var renderChildren = function (currtree, parent) {
    var children = currtree.children;
    var _a = parent.props, id = _a.id, entity = _a.entity, rest = __rest(_a, ["id", "entity"]);
    if (children && children.length > 0) {
        return (React.createElement("div", { className: "legao-tree-list" }, children.map(function (child) {
            // @ts-ignore
            var childNode = entity.getNodes(child)[0];
            if (childNode) {
                return React.createElement(TreeNode, __assign({ key: childNode.key, id: "" + childNode.id, entity: entity }, rest));
            }
            return null;
        })));
    }
    return null;
};
var TreeNode = /** @class */ (function (_super) {
    __extends(TreeNode, _super);
    function TreeNode() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggerExpand = function (e) {
            e.stopPropagation();
            _this.props.toggerExpand(e, _this.props.id);
        };
        _this.selectLeaf = function (e) {
            e.stopPropagation();
            _this.props.selectLeaf(e, _this.props.id);
        };
        _this.toggerCheckbox = function (e) {
            e.stopPropagation();
            _this.props.toggerCheckbox(e, _this.props.id);
        };
        _this.nodeClick = function (e) {
            var _a = _this.props, entity = _a.entity, id = _a.id;
            var currtree = entity.getNodes(id)[0];
            var children = currtree.children;
            if (children && children.length > 0) {
                _this.toggerExpand(e);
            }
            _this.selectLeaf(e);
        };
        return _this;
    }
    TreeNode.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, renderExpand = _d.renderExpand, renderLeaf = _d.renderLeaf, id = _d.id, onDragLeave = _d.onDragLeave, onDragOver = _d.onDragOver, onDrop = _d.onDrop, onDragStart = _d.onDragStart, draggable = _d.draggable, hasCheck = _d.hasCheck, entity = _d.entity, disabled = _d.disabled;
        var currtree = entity.getNodes(id)[0];
        var expanded = currtree.expanded, checkbox = currtree.checkbox, status = currtree.status, children = currtree.children;
        var parent = this;
        var spanNode = (React.createElement(SpanTag, { atomics: ['w-full', 'py-1', 'block'], onClick: this.nodeClick, role: "presentation", className: "legao-tree-node", onDragLeave: onDragLeave, onDragOver: function (e) {
                onDragOver(e, id);
            } }, React.createElement(renderLeaf, {
            node: currtree,
        })));
        var itemCls = classNames((_a = {},
            _a['text-gray-200'] = disabled,
            _a['tree-drag-item'] = draggable && !disabled,
            _a));
        var innerClsString = classNames((_b = {},
            _b['text-gray-200 cursor-not-allowed'] = disabled,
            _b['cursor-pointer text-gray-600'] = !disabled,
            _b));
        var innerCls = innerClsString.split(/\s/g);
        var containClsString = classNames((_c = {},
            _c['text-gray-200 cursor-not-allowed'] = disabled,
            _c['cursor-pointer text-gray-600'] = !disabled,
            _c));
        var containCls = containClsString.split(/\s/g);
        return (React.createElement(DivTag, { atomics: ['pl-px-15', itemCls], draggable: draggable && !disabled ? true : false, autoPrefixedClassName: "tree-main", onDrop: function (e) {
                onDrop(e, id);
            }, onDragStart: function (e) {
                onDragStart(e, id);
            } },
            React.createElement(DivTag, { atomics: __spread([
                    'relative',
                    'flex',
                    'items-center',
                    'pl-px-15',
                    'h-px-32',
                    'text-sm',
                    'leading-px-30'
                ], innerCls), autoPrefixedClassName: "tree-inner" },
                React.createElement(SpanTag, { atomics: __spread([
                        'absolute',
                        'left-0',
                        'top-0',
                        'h-full',
                        'inline-flex',
                        'items-center'
                    ], containCls), onClick: this.toggerExpand, autoPrefixedClassName: "call-down-contain", role: "presentation" }, children && children.length > 0
                    ? React.createElement(renderExpand, {
                        expanded: expanded,
                        disabled: disabled,
                    })
                    : null),
                hasCheck ? (React.createElement(Checkbox, { indeterminate: status === 'semi-checked', onChange: this.toggerCheckbox, checked: !!checkbox }, spanNode)) : (spanNode)),
            !expanded ? null : renderChildren(currtree, parent)));
    };
    return TreeNode;
}(React.Component));
export default TreeNode;
